import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PropertyLedgerCodeModel } from 'app/models/property-ledger-code.model';

@Component({
  standalone: false,
  selector: 'app-ledger-codes',
  templateUrl: './ledger-codes.component.html',
  styleUrls: ['./ledger-codes.component.scss']
})
export class LedgerCodesComponent implements OnInit {
  public ledger_code_model: Array<PropertyLedgerCodeModel>;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.subscribe(({ledger_code_model}) => {
      this.ledger_code_model = ledger_code_model;
  });
  }
}
